var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width: " + _vm.width + "%;height: " + _vm.height + "%;overflow: hidden;z-index: 0;position: relative;"))})}
var staticRenderFns = []

export { render, staticRenderFns }